import { Box } from "@mui/material";
import services from "../../../../../data/services.json";
import ServicesHelmet from "../../../../../Helmets/ServicesHelmet";
import Service from "./Service";

export default function ServicesPage() {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <ServicesHelmet />
      {services.services.map((service) => (
        <Service key={service.title} service={service} />
      ))}
    </Box>
  );
}
